import ToolingManagement from './ToolingManagement';
import ToolingManagementHOC from './ToolingManagementHOC';

export default ToolingManagementHOC(ToolingManagement);



// WEBPACK FOOTER //
// ./src/pages/ToolingManagement/index.jsx